import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../../constants/constants';
import FactorSetWeightLineForm from './addFactorSetWeightLineForm';
import { resetWeightVersionLines, resetFactorSetWeightLine } from '../../../../reducers/weightLineReducer';

interface IAddFactorSetLineProps {
    classes: any;
    theme: Theme;
    match: any;
    weightLineId?: number;
    factorSetWeightId?: number;
    resetWeightVersionLines: any;
    resetFactorSetWeightLine: any;
    factorSetVersionId?: number;
    type: FormType;
    steps: Array<number>;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetWeightVersionLines: () => dispatch(resetWeightVersionLines()),
    resetFactorSetWeightLine: () => dispatch(resetFactorSetWeightLine())
});

const mapStoreToProps = (store: RootState, ownProps: IAddFactorSetLineProps) => {
    return {
        weightLineId: ownProps.match.params?.weightLineId ? Number(ownProps.match.params?.weightLineId) : undefined,
        factorSetWeightId: ownProps.match.params?.weightId ? Number(ownProps.match.params?.weightId) : undefined,
        factorSetVersionId: ownProps.match.params?.factorSetVersionId ? Number(ownProps.match.params?.factorSetVersionId) : undefined
    };
};

class AddFactorSetWeightLine extends Component<IAddFactorSetLineProps> {

    componentWillUnmount() {
        const { resetWeightVersionLines, resetFactorSetWeightLine } = this.props;

        resetWeightVersionLines();
        resetFactorSetWeightLine();
    }

    render() {
        const { classes, steps, weightLineId, factorSetWeightId, type, factorSetVersionId } = this.props;

        return (
            <div>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <FactorSetWeightLineForm weightLineId={weightLineId} factorSetWeightId={factorSetWeightId} steps={steps} type={type}
                            factorSetVersionId={factorSetVersionId} />
                    </CardContent>
                </Card>
            </div>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddFactorSetWeightLine));